export default __webpack_public_path__ + "static/media/action.15a9f17f.svg";